function baseParamIndex(paramSent , paramId){
    var baseParamId;
    if(!paramSent)
        baseParamId = MEData.baseparameter.id;
    else
        baseParamId = paramId;
    var rowFound = false;
    var rowIndex = -1;
    $.each(AlldgRows , function(i,el) {
        if(el.RowAppend && !rowFound) {
            rowIndex += 1;
            if(el.id.split('-')[0] == baseParamId)
                rowFound = true;
        }
    });
    return rowIndex;
}

/*function getBaseParamLineitems() {
    baseParamLineitems = [];
    var lineItems = {};
    $.each(MEData.row_dimensions, function(i,el) {
        if(el.name == "lineitems")
            lineItems = el.values;
    });
    var baseParam = MEData.baseparameter;
    $.each(lineItems , function(i,el) {
        if(el.magnitude == baseParam.magnitude && el.unit == baseParam.unit)
            baseParamLineitems.push(el.id);
    });
}*/

function baseParams() {
    rowindex = baseParamIndex(false, "");
    tableTr = $('#tt').datagrid("getPanel").find('table').eq(3).find('tr').last().find('td');
    dataTr = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr').eq(rowindex);
    baseParameterValues = [];
    $.each(tableTr , function (i,el) {
        var text = dataTr.find("td[field='" + $(el).attr('field') + "']").text().replace(/,/g,'');
        if(text.indexOf('(') > -1) {
            text = text.replace('(','').replace(')','');
            baseParameterValues.push({ "column": $(el).attr('field'), "text": text, 'negative':true ,"dpid":$(el).attr('id')});
        }
        else
            baseParameterValues.push({ "column": $(el).attr('field'), "text": text, 'negative':false ,"dpid":$(el).attr('id')});
    });
    /*else {
        baseParameterValues2 = [];
        $.each(baseParameterValues , function (i,el) {
            var text = dataTr.find("td[field=" + el.column + "]").text().replace(/,/g,'');
            var negativeValue = false;
            if(dataInCommonsize) {
                text = (+text * +baseParameterValues[i]["text"]) /100;
                text = text + "";
                if(text.indexOf('-') > -1) {
                    text = text.replace('-','');
                    negativeValue = true;
                }
            }
            else {
                if(text.indexOf('(') > -1) {
                    text = text.replace('(','').replace(')','');
                    negativeValue = true;
                }
            }    
            baseParameterValues2.push({ "column": el.column, "text": text, 'negative':negativeValue });
        });
        baseParameterValues = baseParameterValues2;
    }*/
}

function dpValueChange(changeType) {
    dataTableTr = $('#tt').datagrid("getPanel").find('table').eq(4).find('tr');
    var footerTr = [];
    var footerObj = [];
    if (!$('#tblIns').is(":visible") && cut !== 'SAR') {
        footerObj = GetFilterData(inspectorType).FilterData;
        footerrowSelected = $('#tt').datagrid('getSelected') == null ? AlldgRows[0].id.split('-')[0] : $('#tt').datagrid('getSelected').id.split('-')[0];
        if($.inArray(footerrowSelected, baseParamLineitems) > -1) {
            footerTr = $('#tt').datagrid("getPanel").find('table').eq(5).find('tr');
        }
        if(inspectorType == 'Drivers'){
            footerObj = jQuery.extend(true, [], driverFilterData);
            footerObj.splice(0,0,footerrowSelected);
        }
        else
            footerObj.splice(0,0,"");
    }
    var appendedRows = $.grep(AlldgRows, function(i,el){
        return i.RowAppend;
    });
    try {
        $.each(baseParameterValues, function (index, value) {
            var eleIndex = $(dataTableTr).eq(0).find("td[field='" + value.column + "']").index();
            $.each(dataTableTr, function (i, el) {
                if ($.inArray("growthtype", rowDimension) != -1 && appendedRows[i].id && appendedRows[i].id.split("-")[appendedRows[i].id.split("-").length - 1] != 'analytics') {
                    return;
                }
                if (rowDimension.length > 1) {
                    rowId = appendedRows[i].id.split('-')[0]
                    newValue = value[appendedRows[i].id.replace(rowId, MEData.baseparameter.id)];
                }
                else
                    newValue = value;
                if ($.inArray(appendedRows[i].id.split('-')[0], baseParamLineitems) > -1)
                    cellCommonsize($(el).find('td').eq(eleIndex), changeType, newValue, true, "");
            });
            if (footerTr.length > 0) {
                $.each(footerTr, function (i, el) {
                    if (inspectorType != 'Drivers') {
                        if (footerObj[i] == "" || footerObj[i] == undefined)
                            newValue = value;
                        else {
                            newValue = value[MEData.baseparameter.id + footerObj[i].toLowerCase()];
                            if (newValue == undefined)
                                newValue = value;
                        }
                    }
                    else {
                        if ($.inArray(footerObj[i], baseParamLineitems) > -1)
                            newValue = value;
                        else
                            return;
                    }
                    cellCommonsize($(el).find('td').eq(eleIndex), changeType, newValue, true, "");
                });
            }
        });
    }
    catch (ex){
        console.error('error :', ex);
    }
}

function cellCommonsize(tableTd, changeType, basevalue, cellValueExist, cellvalue) {
    var el = tableTd;
    if(changeType){
        if(cellValueExist)
            tdData = $(el).find('div').html();
        else{
            if(cellvalue.charAt(0) == '(')
                cellvalue = "-" + cellvalue.replace('(','').replace(')','');
            tdData = formatValue(cellvalue);
        }
        $(el).attr('cellvalue',tdData);
    }
    else{
        $(el).find('div').html($(el).attr('cellvalue'));
        return;
    }
    var value = basevalue;
    if(value == undefined)
        value = { "column": $(tableTd).attr('field'), "text": "", 'negative':false,"dpid":0};
    var negativeType = value.negative;
    var cellText;
    if(cellValueExist)
        cellText = $(el).text().replace(/,/g,'').replace('%','');
    else
        cellText = cellvalue.replace(/,/g,'').replace('%','');
    if(cellText != "" && cellText != "NA" && value.text != "") { //it should not do anything if value or text is null
        if(cellText.indexOf('(') > -1) {
            negativeType = !(value.negative);
            cellText = cellText.replace('(','').replace(')','');
        }
        TextValue = PercentageValue(cellText , value.text, changeType , negativeType);
        $(el).find('div').html(formatValue(TextValue + ""));
        if(changeType){
            var divText = $(el).text();
            if(divText.charAt(0) == '('){
                //Adding an extra replace here, since (-) sign is still there when we show it in %
                divText = divText.replace(')','%)').replace('-','');
                $(el).find('span').text(divText);
            }
            else
                $(el).find('div').text(divText + '%');
        }
    }
    else if(cellText == "NA" && (!changeType) && value.text =="") {
        valueCell = $(el).attr('dpvalue');
        if(valueCell.charAt(0) == '(') {
            valueCell = valueCell.replace('(','').replace(')','');
            $(el).find('div').html(formatValue("-" + valueCell));
        }
        else {
            $(el).find('div').html(formatValue(valueCell));
        }
    }
    else if(changeType && value.text == "" && cellText != "") {
        $(el).attr('dpvalue',cellText).find('div').text("NA");
    }
}

function PercentageValue(cellValue , baseValue , type, negativeType) {
    var textValue;
    if(cellValue)
        textValue = (+cellValue * 100)/(+baseValue);
    else
        textValue = (+cellValue * +baseValue)/(100);
    if(negativeType)
        return -1 * textValue;
    else
        return textValue;
}

function commonStatementChanged() {
    //alert(MEData.baseparameter.id);
    var commonStatementValue = $('#commonStatement').val();
    if(commonStatementValue != MEData.baseparameter.name) {
        commonvalue = $.grep(MEData.baseparametervalues, function(i,el) {
            if(commonStatementValue == i.name)
                return i;
        });
        MEData.baseparameter = commonvalue[0];
        if(dataInCommonsize) {
            //to do change the dropdown successful without iteration
            dataInCommonsize = false;
            dpValueChange(dataInCommonsize);
            baseParams();
            dataInCommonsize = true;
            dpValueChange(dataInCommonsize);
        }
        else
            baseParams();
    }
}

currentClickedCommonSizeName = null;

function dataTranform(ele) {// todo : check this I think it was for the top toggle
    var clickedValue = $(ele).attr('value');
    //Remove any selected class on any of the 3 buttons first.

    if (clickedValue == currentClickedCommonSizeName)
        return;
    currentClickedCommonSizeName = clickedValue;
    $("#commonsizeToggleTable").find(".miniButtonsSelected").removeClass("miniButtonsSelected");
    if (clickedValue == 'commonsize') {
        //$('#commonsizeToggleTable').removeClass().addClass('commonsize-active');
        //Adding this to change the grid back to number format, and then do the commonsize % calculation
        $("#toggle-commonsize").find("div").addClass("miniButtonsSelected");
        dataInCommonsize = true;
        dpValueChange(dataInCommonsize);
    }
    else if(clickedValue == 'normal'){
        //$('#commonsizeToggleTable').removeClass().addClass('normal-active');
        $("#toggle-normal").find("div").addClass("miniButtonsSelected");
        dataInCommonsize = false;
        dpValueChange(dataInCommonsize);
    }
    else{
        $("#toggle-yoy").find("div").addClass("miniButtonsSelected");
        dataInCommonsize = false;
        dpValueChange(dataInCommonsize);
        currentSelectedLineId = $(".datagrid-view1 .datagrid-row-selected").find("[field='lineitems']").attr("id");
        if(!$("[id='growth-type-checkbox-yoy%']").is(":checked")) {
            //Checking whether the Analytics clear is enabled and if the YoY% is also selected to ensure that clicking the YoY% button won't retrigger it
            isYoyTheLastSelection = true;
            $("[id='growth-type-checkbox-yoy%']").trigger("click");

            $("#options-refresh-buttons-apply-GrowthTypes").trigger("click");
        }
        else{
            var selectedExpansionTd = $("[id='" + currentSelectedLineId + "']").eq(0).closest("tr").find("[field='GrowthTypes'] img").eq(0).closest('td');
            if(!$(selectedExpansionTd).hasClass('expanded-row-header')) {
                $(selectedExpansionTd).trigger("click");
                $('.datagrid-btable').find('.growth[field=GrowthTypes]').addClass('current-change');
            }
            //set timeout for 5 seconds to remove yellow accent for analytics
            setTimeout(function () {
                $('td.current-change.growth').removeClass('current-change');
            }, 5000);
        }
    }
}


// todo : Remove this function if commonsize functionality will not be needed again
function getBaseParamData(periodvalue, objParameter, responseData){
    var Url = {"mainUrl": "/api/param2?"};
    Url['param'] = [MEData.baseparameter.id];
    Url["period"] = [];
    var parameter = objParameter;
    var periodsUrl = [];
    var objWS = new WebServiceCall();
    $.each(rowDimension, function (index, value) {
        if(value == 'lineitem' || value == 'link')
            return;
        if( !Url.hasOwnProperty(value))
            Url[value] = [];
        expansions = FindExpansions(value + 's', periodvalue);
        if (expansions){
            $.each(expansions, function(i,el){
            //url += '&' + value + '=' + el;
                Url[value].push(el);
            });
        }
        //url += '&' + value + '=' + rowDefaults[value];
        if(rowDefaults[value] != '')
            Url[value].push(rowDefaults[value]);
    });
    if (rowDimension.length > 2){
        $.each(colDimension, function (index, value) {
            if (value == 'period') {
                return;
            }
            if( !Url.hasOwnProperty(value))
                Url[value] = [];
            expansions = FindExpansions(value + 's', periodvalue);
            if (expansions) {
                $.each(expansions, function (i, el) {
                    Url[value].push(el);
                });
            }
            if (value == 'revision') {
                Url[value].push('Current');
            }
        });
    }
    if(gSource == ""){
        Url = makeUrl(Url,gSource);
        $.each(periods, function (index, value) {
            Url["period"].push(value);
        });
        parameter.type = 'future';
        parameter.Url = Url;
        parameter.Data = responseData;
        objWS.getBaseParamRelatedData(parameter);
        return;
    }
    if(periodvalue == ""){
        $.each(periods, function (index, value) {
            if(sourcesExist){
                if((!parameter.type) || parameter.type != 'future'){
                    parameter.type = 'past';
                    if(!currentCheck(value,company))
                        periodsUrl.push(value);
                }
                else{
                    if(currentCheck(value,company))
                        periodsUrl.push(value);
                }
            }
            else
                periodsUrl.push(value);
        });
    }
    else{
        if(sourcesExist){
            if(currentCheck(periodvalue,company))
                parameter.type = 'future';
            else
                parameter.type = 'past';
        }
        periodsUrl.push(periodvalue);
    }
    if(parameter.type){
        if( !Url.hasOwnProperty("source") )
            Url["source"] = [];
        if(parameter.type == 'past')
            Url["source"].push(gSourceActual);
        else
            Url["source"].push(gSourceFuture);
    } else{
        if(Url["source"])
            Url["source"].push(gSource);
        else
            Url["source"] = [gSource];
    }

    $.each(periodsUrl, function(i,el){ Url["period"].push(el); });
    if (Url["period"].length == 0){
        if(parameter.type == 'past')
            getBaseParamData(periodvalue,{'type': 'future'}, responseData);
        else
            functionToRecieveBaseParamData(responseData);
        return;
    }
    Url = makeUrl(Url,gSource);
    parameter.Url = Url;
    parameter.Data = responseData;
    objWS.getBaseParamRelatedData(parameter);
}


function functionToRecieveBaseParamData(data){
    if(data.length == 0)
        return;
    //collect baseparamrows
    baseparamrows = [];
    $.each(AlldgRows, function(i,el){
        if(el.id.split('-')[0] == MEData.baseparameter.id)
            baseparamrows.push(el.id);
    });
    //make row-id's and column names from data
    $.each(data, function(index,value){
        var rowid = "", columnName = "";
        $.each(rowDimension, function(i,el){
            if (el == 'link')
                return;
            if( i == 0)
                rowid = String(value.param);
            else
                rowid += '-' + value[el];
        });
        rowid = rowid.toLowerCase();
        //column name
        $.each(colDimension, function(i,el){
            columnName += value[el];
        });
        value.rowid = rowid;
        value.fieldName = columnName.toLowerCase();
    });
    //include new baseparamvalues in existing one's
    $.each(baseParameterValues, function(index,value){
        columnName = value.column;
        var dataValues = $.grep(data, function(i,el){
            return (i.fieldName == columnName)
        });
        // including baseparamvalue inside it
        var basevalue = jQuery.extend(true,{}, value);
        rowParameter = "";
        $.each(rowDimension, function(i,el){
            if (el == 'link')
                return;
            if( i == 0)
                rowParameter = String(MEData.baseparameter.id);
            else
                rowParameter += '-' + rowDefaults[el];
        });
        value[rowParameter.toLowerCase()] = basevalue;
        $.each(dataValues, function(i,el){
            if($.inArray(el.rowid, baseparamrows) > -1){
                obj = {};
                obj.column = columnName;
                if(el.data.length == 0)
                    el.data.push({value: "", id: 0});
                var baseDpValue = el.data[0];
                if (baseDpValue.value && baseDpValue.value.charAt(0) == '-'){
                    obj.negative = true;
                    obj.text = baseDpValue.value.replace('-','');
                }
                else{
                    obj.negative = false;
                    obj.text = baseDpValue.value;
                }
                obj.dpid = baseDpValue.id;
                value[el.rowid] = obj;
            }
        });
    });
}

function sortDataArray(arrayData){
    baseData = $.grep(arrayData, function(i,el){
        return (i['param_id'] == MEData.baseparameter.id);
    });
    if(baseData.length != 0)
        arrayData.splice(0,0,baseData[0]);
}

function appendValuesInBaseParameter(valuerowdata, baseParamValue, objColField, objRowField){
    //include new baseparamvalues in existing one's
    if (valuerowdata.param_id == MEData.baseparameter.id) {
        baseColumnData = $.grep(baseParameterValues, function (baseValue, baseIndex) {
            if (baseValue.column == objColField)
                return baseValue;
        });
        baseParamValue = baseColumnData[0];
        if (baseParamValue) {
            var obj = {};
            obj.column = objColField;
            if (valuerowdata.value && valuerowdata.value.charAt(0) == '-') {
                obj.negative = true;
                obj.text = valuerowdata.value.replace('-', '');
            } else {
                obj.negative = false;
                obj.text = valuerowdata.value;
            }
            obj.dpid = valuerowdata.id;
            baseParamValue[objRowField] = obj;
        }
    }
}